import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { ReactComponent as Arrow } from '../../../webcommon/common/Icons/Arrow-Right.svg';
import { ReactComponent as ArrowHighlighted } from '../../../webcommon/common/Icons/Arrow-Right-Highlighted.svg';
import { noop } from 'lodash';

const TemplateRow = props => (
    <button
        type="button"
        className={ classnames({
            [props.styles.activeTemplateRow]: props.activeRow,
            [props.styles.templateRow]: true

        }) }
        onClick={ props.setCurrentOption }
    >
        <span className={ props.styles.templateIcon }>
            {props.icon}
        </span>
        <span className={ props.styles.templateText }>
            {props.message}
        </span>
        {props.showExtendIcon
            ? (
                <span className={ props.styles.templateIconRight }>
                    {props.activeRow ? <ArrowHighlighted /> : <Arrow />}
                </span>
            ) : null}
    </button>
);

TemplateRow.propTypes = {
    activeRow: PropTypes.bool,
    icon: PropTypes.element,
    message: PropTypes.string,
    setCurrentOption: PropTypes.func,
    showExtendIcon: PropTypes.bool,
    styles: PropTypes.objectOf(PropTypes.string).isRequired
};

TemplateRow.defaultProps = {
    activeRow: false,
    icon: noop,
    message: '',
    setCurrentOption: noop,
    showExtendIcon: false
};

export default TemplateRow;
